import costuto from '@/apis/costuto.js'
import helpers from '@/store/helpers.js'

const modules = {
  users: {
    namespaced: true,
    actions: {
      create: (context, payload) => {
        return new Promise((resolve, reject) => {
          let data = helpers.dataFormat('search', payload)
          costuto().post(`search/users`, data)
            .then(resp => {
              resolve(resp)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    }
  },
  publications: {
    namespaced: true,
    actions: {
      create: (context, params) => {
        return new Promise((resolve, reject) => {
          let data = helpers.dataFormat('publication', params)
          costuto().post('search/publications', data)
            .then(resp => {
              resolve(resp)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    }
  },
  stores: {
    namespaced: true,
    actions: {
      create: (context, params) => {
        return new Promise((resolve, reject) => {
          let data = helpers.dataFormat('store', params)
          costuto().post('search/stores', data)
            .then(resp => {
              resolve(resp)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    }
  }
}

export default {
  namespaced: true,
  modules
}
